<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(prenotazione.id != null ? 'Prenotazione #' + prenotazione.id + ' - Impianto #' + prenotazione.id_scheda + ' - ' + prenotazione.nominativoimpianto : 'Nuova prenotazione' + ' - Impianto #' + prenotazione.id_scheda)">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio1 || prenotazione.id == null) && showdettaglio3">                                
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datainizio">Data inizio prenotazione:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="prenotazione.datainizio" id="datainizio" type="date" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datafine">Data fine prenotazione:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="prenotazione.datafine" id="datafine" type="date" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="orainizio">Ora inizio prenotazione:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="prenotazione.orainizio" id="orainizio" type="time" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="orafine">Ora fine prenotazione:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="prenotazione.orafine" id="orafine" type="time" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="socio2Vis != ''">
                                    <b-col sm="3"><label for="orafine">Secondo partecipante:</label></b-col>
                                    <b-col sm="9">
                                        <b-link v-on:click="dettagliosocio2()"><b>{{socio2Vis}}</b></b-link>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="importosaldo">Saldo totale:</label></b-col>
                                    <b-col sm="9">                                    
                                        <b-input-group prepend="€">
                                            <b-form-input v-model="prenotazione.importosaldo" id="importosaldo" type="text"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="note">Note:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea id="note" v-model="prenotazione.note" :rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>
                               
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flagsta">Stato:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="prenotazione.flagsta" :options="options_stati" id="flagsta">
                                            
                                        </b-form-select>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">

                                    <b-col sm="3"><label for="socio">Socio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="socioVis" id="socio" type="text" disabled></b-form-input>
                                    </b-col>
                                    
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="msgpreno">Messaggio accettazione condizioni (es.: Covid):</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea disabled id="msgpreno" v-model="prenotazione.msgpreno" :rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flgacpmsgpreno">Accettazione condizioni:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="flgacpmsgprenoVis" id="flgacpmsgpreno" type="text" disabled></b-form-input>
                                     
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="prenotazione.id != null">
                                    <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="prenotazione.datains" id="datains" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>                                
                                <b-row class="my-1" v-if="prenotazione.id != null">
                                    <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="prenotazione.uteins" id="uteins" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>

                                <!-- ATTENZIONE: per ora si commenta non sono gestiti i pagamenti per impianto
                                <b-row class="my-3" v-show="parametri.flgpagamenti == 'S' && prenotazione.id != null && prenotazione.id_socio != null">
                                    <b-col sm="9" offset-sm="3">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="pagamenti()">
                                            Pagamenti
                                        </b-button>
                                    </b-col>                                    
                                </b-row>
                                -->
                                
                                <b-row class="my-3">
                                    <b-col sm="6" offset-sm="3">
                                        <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                            <div v-if="prenotazione.id != null">
                                                Salva
                                            </div>
                                            <div v-else>
                                                Inserisci
                                            </div>
                                        </b-button>
                                    </b-col>
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>

                </b-card>
            </b-col>
        </b-row>
    </b-container>          

</div>
</template>

<script>
import moment from 'moment'

import {
    NAMESPACE,
} from '../config.js'

import {
    Prenotazione,
} from '../classes.js'

import {
    ctrlVismenu
} from '../util.js'



export default {
    name: 'appdettaglio',
    data: function () {
        return {                        
            namespace: NAMESPACE,
            prenotazione: {
                id: this.$route.params.id,
                id_scheda: this.$route.params.id_scheda,
                importosaldo: 0,
                datainizio: '',
                datafine: '',
                note: '',
                datains: null,
                uteins: '',
                id_socio: null,
                nomesocio: '',
                cognomesocio: '',
                accountsocio: '',
                orainizio: '',
                orafine: '',
                flagsta: 'I',
                id_socio2: null,
                cognomesocio2: '',
                nomesocio2: '',
                emailsocio2: '',
                accountsocio2: '',
                tipo: 'I',
                msgpreno: '',
                flgacpmsgpreno: 'N',
            },
            parametri: null,
            options: [],
            options_stati: [],
            options_msgpreno: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            error: '',
            showerror: false,
            showdettaglio1: false, 
            showdettaglio3: false, 
            dismissSecs: 2,
            dismissCountDown: 0,            
        };
    },
    computed:{
        
        flgacpmsgprenoVis: {
            // getter
            get: function () {
               
                return (this.prenotazione.flgacpmsgpreno == 'N' ? 'No' : 'Sì');
            },
            // setter
            set: function (newValue) {

            }
        },
        socioVis: {
            // getter
            get: function () {
                if(this.prenotazione.id_socio == null || this.prenotazione.id_socio == 'null' || parseInt(this.prenotazione.id_socio) <= 0){
                    return '';
                }
                else{
                    return this.prenotazione.cognomesocio + " " + this.prenotazione.nomesocio + " - " + this.prenotazione.accountsocio;
                }
                
            },
            // setter
            set: function (newValue) {

            }
        },
        socio2Vis: {
            // getter
            get: function () {
                if(this.prenotazione.id_socio2 == null){
                    return '';
                }
                else{
                    return this.prenotazione.cognomesocio2 + " " + this.prenotazione.nomesocio2 + " - " + this.prenotazione.accountsocio2;
                }
                
            },
            // setter
            set: function (newValue) {

            }
        },
    },
    methods: { 
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        }, 
        dettagliosocio2() {

            this.$router.push({
                path: `/app/dettagliosocio/${this.prenotazione.id_socio2}`
            });

        },
        pagamenti() {

            this.$router.push({
                path: `/app/pagamenti/id_impianto/${this.prenotazione.id_scheda}/id_socio/${this.prenotazione.id_socio}/id_prenotazione/${this.prenotazione.id}`
            });
            
        },
        insert() {

                var appdettaglio = this;
                
                var json = JSON.stringify(this.prenotazione);

                //console.log(json);

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/prenotazione', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.prenotazione = res[0];
                                    this.showerror = false;
                                    this.showdettaglio1 = true; //anche se non dovrebbe servire

                                    setTimeout(function() {
                                        //window.history.back();
                                        appdettaglio.$router.go(-1);
                                    }, 2500);

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });
                

            }

    },
    created: function () {   

           
        
            if(!ctrlVismenu("R")){
                this.$router.replace('/accessdenied');
                return;
            }
            
            var prenotazione1 = new Prenotazione();
            var options = [];
            var listaStati = Object.keys(prenotazione1.getListaStati("I"));
            for (var i = 0; i < listaStati.length; i++) {
                options.push({
                    value: listaStati[i],
                    text: prenotazione1.getStatoByFlag(listaStati[i])
                });
            }
            this.options_stati = options;

            var id = this.prenotazione.id; //se è la prima volta si prova a prendere da getid 

            var appdettaglio = this;
            var token = localStorage.getItem('token');
            if (id != null) {          

                this.axios.get(NAMESPACE + 'rest/prenotazioni/tipo/I/'+ id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;                                

                                if (res.length > 0) {
                                    appdettaglio.prenotazione = res[0];
                                    appdettaglio.showdettaglio1 = true;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });
            }

            //PAREMETRI
            this.axios.get(NAMESPACE + 'rest/cral', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            //alert("Ret: " + JSON.stringify(res))
                            if (typeof res == "object") {

                                this.parametri = res;
                                this.showdettaglio3 = true;

                            } else {
                                throw new Error("Errore parametri non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

    },
    mounted: function() {
        
        
        
    }

}
</script>
